/*!
 * Copyright (c) 2020 Digital Bazaar, Inc. All rights reserved.
 */
export {Ed25519VerificationKey2020} from './Ed25519VerificationKey2020.js';
